import React, { useEffect, useState } from "react";
import Banner from "../component/Banner";
import BannerImg from "../image/gallaryBanner.png";
import Header from "../component/header";
import Footer from "../component/Footer";
import { timeAgo } from "../utilis/Time";
import { FaEye, FaFileDownload } from "react-icons/fa";
import ViewProject from "../component/modals/ViewProject";
import ProjectForm from "../component/ProjectForm";
import axios from "axios";
import Editproject from "../component/modals/Editproject";
import UpgradePrompt from "../component/access/UpgradePrompt";
import useAccess from "../hooks/useAccess";
const Projects = () => {
  const [projects,setProjects]=useState([]); 
  const [selectedProjectForView, setSelectedProjectForView] = useState(null);
const [selectedProjectForEdit, setSelectedProjectForEdit] = useState(null);
  const { canSubmitProject, tierKey } = useAccess();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        duration: 0.8,
      },
    },
  };
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };
  const getProject=async()=>{
      try {
      const res = await axios.get(
        "/api/project/get",
        {
          withCredentials: true,
        }
      );
       if(res.data.success){
      setProjects(res.data.data); 
      }
    } catch (err) {
      console.error(err.response?.data || err.message);
    }
      }
  useEffect(()=>{
       getProject();
  },[]) 
 

const handleDelete = async(id) => {
   const res=await axios.post(`/api/project/${id}/delete`,{
      withCredentials: true, // ✅ send cookie
    })
    if(res.data.success){
       getProject();
       alert(res.data.message || "Project deleted successfully")
    }
};
const handleDownload = async (id, title) => {
  try {
    const res = await axios.get(`/api/project/${id}/download`, {
      withCredentials: true, // ✅ send cookie
      responseType: "blob",   // ✅ important for PDF/binary
    });

    // Create a Blob from the response
    const pdfBlob = new Blob([res.data], { type: "application/pdf" });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(pdfBlob);

    // Create a temporary <a> tag and trigger download
    const link = document.createElement("a");
    link.href = url;

    // Use project title for filename, fallback to id
    link.download = title
      ? `${title.replace(/[^a-z0-9]/gi, "_").toLowerCase()}.pdf`
      : `${id}.pdf`;

    document.body.appendChild(link);
    link.click();

    // Clean up
    link.remove();
    window.URL.revokeObjectURL(url);

    alert("Project downloaded successfully!");
  } catch (err) {
    console.error(err.response?.data || err.message);
  }
};

const memberDisplayName = (member = {}) =>
  member?.preferredName ||
  [member?.firstName, member?.lastName].filter(Boolean).join(" ").trim() ||
  member?.memberId ||
  "Member";

  return (
    <div>
      <Header />
      <Banner
        backgroundImage={BannerImg}
        heading="Projects"
        // paragraph="The LWBL Gallery showcases exceptional artworks submitted by artists at every stage of their creative journey. Browse through emerging talent, challenge-winning pieces, and curated themes—all in a beautifully organized digital space that celebrates creativity, skill, and artistic expression."
        minHeight="60vh"
        padding="80px 0"
        bton="Members please sign-in"
      />
      {/* Main Content  */}
     <section className="main-lwbl bg-[#F9FAFB] py-16 px-4 rounded-[30px]">
  <div className="max-w-7xl mx-auto">

    {/* Heading */}
    <div className="text-center mb-10">
      <h4 className="text-sm md:text-base text-[#555] font-outfit">
        Stay updated on project milestones, upcoming challenges, and
        collaborative initiatives.
      </h4>

      <h2 className="text-[32px] md:text-[40px] font-cinzel mt-2">
        What’s New in LWBL Projects
      </h2>

      <p className="text-sm md:text-base text-[#555] mt-2">
        Innovation is always in motion. Our project calendar keeps you
        updated on every opportunity to contribute and grow.
      </p>
    </div>

    {/* Table */}
    <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
      <table className="min-w-full text-left border-collapse">
        <thead className="bg-gray-100 text-gray-600 uppercase text-sm">
          <tr>
            <th className="px-6 py-4">Image</th>
            <th className="px-6 py-4">Title</th>
            <th className="px-6 py-4">Description</th>
            <th className="px-6 py-4">Project By</th>
            <th className="px-6 py-4">Created</th>
            <th className="px-6 py-4 text-center">Actions</th>
          </tr>
        </thead>

        <tbody className="text-gray-700 text-sm">
          {projects.map((project) => (
            <tr
              key={project._id}
              className="border-b hover:bg-gray-50 transition"
            >
              {/* Image */}
              <td className="px-6 py-4">
                <img
                  src={project.image}
                  alt="project"
                  className="w-16 h-12 object-cover rounded-md"
                />
              </td>

              {/* Title */}
              <td className="px-6 py-4 font-semibold">
                {project.title}
              </td>

              {/* Description */}
              <td className="px-6 py-4">
                {project.description.slice(0, 60)}...
              </td>

              {/* Project By */}
              <td className="px-6 py-4 flex items-center gap-3">
                <img
                  src={project?.project_by?.pfp}
                  alt="avatar"
                  className="w-8 h-8 rounded-full"
                />
                {memberDisplayName(project?.project_by)}
              </td>

              {/* Created */}
              <td className="px-6 py-4">
                {timeAgo(project.createdAt)}
              </td>

              {/* Actions */}
              <td className="px-6 py-4">
                <div className="flex justify-center gap-3">

                 {/* View */}
<button
  onClick={() => setSelectedProjectForView(project)}
  className="px-3 py-1 text-xs bg-blue-100 text-blue-600 rounded hover:bg-blue-200 transition"
>
  View
</button>

{/* Edit */}
<button
  onClick={() => setSelectedProjectForEdit(project)}
  className="px-3 py-1 text-xs bg-yellow-100 text-yellow-600 rounded hover:bg-yellow-200 transition"
>
  Edit
</button>

                  <button
                    onClick={() => handleDownload(project._id, project.title)}
                    className="px-3 py-1 text-xs bg-green-100 text-green-600 rounded hover:bg-green-200 transition"
                  >
                    Download
                  </button>

                  {/* Delete */}
                  <button
                    onClick={() => handleDelete(project._id)}
                    className="px-3 py-1 text-xs bg-red-100 text-red-600 rounded hover:bg-red-200 transition"
                  >
                    Delete
                  </button>

                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

  </div>

  {/* View Modal */}
  <ViewProject
  isOpen={!!selectedProjectForView}
  project={selectedProjectForView}
  onClose={() => setSelectedProjectForView(null)}
/>

<Editproject
  isOpen={!!selectedProjectForEdit}
  project={selectedProjectForEdit}
  onClose={() => setSelectedProjectForEdit(null)}
  onUpdate={getProject}
/>

</section>

       {/* Project Form — gated to kindred+ */}
       <div className="main-lwbl bg-[#F9FAFB] py-16 px-[1rem] overflow-hidden rounded-[30px]">
          {canSubmitProject ? (
            <ProjectForm/>
          ) : (
            <UpgradePrompt reason="tier" currentTier={tierKey} requiredTier="kindred" />
          )}
       </div>
      <Footer />
    </div>
  );
};

export default Projects;
